import React from 'react';

const Heading = ({ children }) => (
  <h2 className="text-sm font-bold uppercase tracking-wide text-[#2F5F92] mt-8 mb-3">{children}</h2>
);

const ReturnPolicy = () => (
  <div className="min-h-screen bg-gray-50 pt-24 pb-12">
    <div className="container max-w-4xl text-[#1F1F1F]">
      <h1 className="text-3xl font-bold text-[#17365D] border-b-2 border-[#4F81BD] pb-2 mb-4">
        Next Level Games Pre-Owned Video Game Return Policy
      </h1>

      <Heading>1. Eligibility for Returns</Heading>
      <ul className="space-y-1">
        <li>• Returns are accepted within 7 days of purchase.</li>
        <li>• The item must be in the same condition as sold and include all original packaging, if applicable.</li>
        <li>• The receipt is required for all returns or exchanges.</li>
      </ul>

      <Heading>2. Types of Returns</Heading>
      <p className="font-bold">Defective Games</p>
      <p className="mb-3">
        If a game is defective, customers may exchange it for the same title (if available) or receive store credit.
      </p>
      <p className="font-bold">Non-Defective Games</p>
      <p>
        Returns for non-defective games may be exchanged for store credit only, minus a restocking fee (e.g., $3 or
        10% of the game's price).
      </p>

      <Heading>3. Non-Returnable Items</Heading>
      <ul className="space-y-1">
        <li>• Games marked as "Final Sale" or purchased from clearance bins.</li>
        <li>• Games showing signs of excessive wear, damage, or tampering after the sale.</li>
      </ul>

      <Heading>4. Inspection Policy</Heading>
      <p>All returned games will be tested in-store before processing the return or exchange.</p>

      <Heading>5. Exceptions</Heading>
      <p>At the discretion of management, exceptions may be made for extenuating circumstances.</p>
    </div>
  </div>
);

export default ReturnPolicy;
